/* ==========================================================================
   Joeps PDP - variant resolution, gallery, accessory add-on, multi-item add.
   Wired to Shopify product.variants JSON. Vanilla, deferred.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('.pdp-m');
  if (!root) return;

  var dataEl = document.querySelector('[data-pdp-variants]');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
  var CUR = (dataEl && dataEl.getAttribute('data-currency')) || 'EUR';
  var LOC = (dataEl && dataEl.getAttribute('data-locale')) || 'nl-NL';

  var form = document.getElementById('pdp-form');
  var idInput = document.querySelector('[data-pdp-variant-id]');

  function money(cents) {
    try {
      var s = new Intl.NumberFormat(LOC, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
      return s.replace(/,00$/, ',-');
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, ',-'); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function $(sel) { return document.querySelector(sel); }
  function $all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  /* ---- Selected option state -------------------------------------------- */
  var groups = $all('[data-option-group]');
  var curId = idInput ? parseInt(idInput.value, 10) : null;
  var curVar = variants.filter(function (v) { return v.id === curId; })[0] || variants[0];
  var selected = curVar ? curVar.options.slice() : [];
  var currentBase = curVar ? curVar.price : 0;
  function accDelta() { var sum = 0; $all('[data-pdp-accessory]').forEach(function (ac) { if (ac.getAttribute('aria-checked') === 'true') { sum += parseInt(ac.getAttribute('data-acc-price'), 10) || 0; } }); return sum; }
  function showPrice(base) { var t = base + accDelta(); var el = document.querySelector('[data-pdp-price]'); if (el) el.textContent = money(t); var s = document.querySelector('[data-pdp-sticky-price]'); if (s) s.textContent = money(t); }

  groups.forEach(function (group) {
    var pos = parseInt(group.getAttribute('data-option-group'), 10);
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      /* Bij role="radio" hoort aria-checked; aria-pressed wordt daar genegeerd, dus
         een schermlezer hoorde wel "keuzerondje" maar nooit welke gekozen was. */
      group.querySelectorAll('[data-option-value]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');
      selected[pos - 1] = btn.getAttribute('data-option-value');
      var lbl = $('[data-pdp-option-label="' + pos + '"]');
      if (lbl) lbl.textContent = selected[pos - 1];
      resolve();
    });
  });

  function resolve() {
    var match = variants.filter(function (v) {
      for (var i = 0; i < selected.length; i++) { if (v.options[i] !== selected[i]) return false; }
      return true;
    })[0];

    if (!match) { setAvailable(false, 'Niet beschikbaar'); return; }
    if (idInput) idInput.value = match.id;

    if (window.history && window.history.replaceState) {
      var u = new URL(window.location); u.searchParams.set('variant', match.id); window.history.replaceState({}, '', u);
    }

    currentBase = match.price;
    showPrice(currentBase);

    var cmp = (match.compare_at_price && match.compare_at_price > match.price) ? match.compare_at_price : 0;
    toggleCompare(cmp, match.price);

    $all('[data-pdp-instalment]').forEach(function (el) { el.textContent = money(Math.round(match.price / 3)); });

    var line = $('[data-pdp-variant-line]');
    if (line) line.innerHTML = match.options.map(function (o, i) { return i === 0 ? '<b>' + esc(o) + '</b>' : ' · ' + esc(o); }).join('');

    if (match.featured_image && match.featured_image.src) {
      var img = $('[data-pdp-main-image]');
      if (img) { var src = match.featured_image.src; img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900'; img.removeAttribute('srcset'); }
    }

    var stockInfo = updateStock(match.id);
    /* Pre-order (snippets/preorder-datum): knop heet dan "Pre-order" en de leverdatum gaat als regeleigenschap mee. */
    var preM = /^Pre-order, (.*)$/.exec((stockInfo && stockInfo.sticky) || '');
    var preIn = $('[data-pdp-pre]');
    if (preIn) { if (preM) { preIn.value = preM[1]; preIn.disabled = false; } else { preIn.disabled = true; } }
    /* Backorder (snippets/backorder): knop heet dan "Bestellen" en de backorderregel gaat mee. */
    var backM = /^Backorder: /.test((stockInfo && stockInfo.sticky) || '');
    var backIn = $('[data-pdp-back]');
    if (backIn) backIn.disabled = !backM;
    setAvailable(match.available, match.available ? (backM ? 'Bestellen' : (preM ? 'Pre-order' : 'In winkelwagen')) : 'Uitverkocht', stockInfo);
  }

  /* ---- Stock indicator: voorraad in / 0 uit; low is alleen pre-order ---- */
  var stockEl = $('[data-pdp-stock]');
  var stockMap = {};
  var stockTxtMap = {};
  var stickyTxtMap = {};
  try { stockMap = JSON.parse((stockEl && stockEl.getAttribute('data-stockmap')) || '{}'); } catch (e) { stockMap = {}; }
  try { stockTxtMap = JSON.parse((stockEl && stockEl.getAttribute('data-stocktxtmap')) || '{}'); } catch (e) { stockTxtMap = {}; }
  try { stickyTxtMap = JSON.parse((stockEl && stockEl.getAttribute('data-stickytxtmap')) || '{}'); } catch (e) { stickyTxtMap = {}; }
  var STOCK_TXT = { 'in': '<span><b>Op voorraad.</b> Op werkdagen vóór 22.00 besteld = dezelfde dag direct verzonden uit ons eigen magazijn!</span>', 'out': 'Tijdelijk uitverkocht' };
  function updateStock(id) {
    if (!stockEl) return { state: 'in', sticky: 'Op voorraad' };
    var st = stockMap[id] || 'in';
    var txt = stockTxtMap[id] || STOCK_TXT[st] || STOCK_TXT.in;
    var sticky = stickyTxtMap[id] || (st === 'out' ? 'Tijdelijk uitverkocht' : 'Op voorraad');
    stockEl.classList.remove('pdp-m__stock--in', 'pdp-m__stock--low', 'pdp-m__stock--out');
    stockEl.classList.add('pdp-m__stock--' + st);
    stockEl.innerHTML = '<span class="dot"></span>' + txt;
    return { state: st, sticky: sticky };
  }

  function setText(sel, txt) { var el = $(sel); if (el) el.textContent = txt; }
  function toggleCompare(cmp, price) {
    var was = $('[data-pdp-compare]'), save = $('[data-pdp-save]'), sWas = $('[data-pdp-sticky-compare]');
    if (cmp) {
      if (was) { was.textContent = 'Adviesprijs ' + money(cmp); was.hidden = false; }
      if (save) { save.textContent = 'Je bespaart ' + money(cmp - price); save.hidden = false; }
      if (sWas) { sWas.textContent = money(cmp); sWas.hidden = false; }
    } else { if (was) was.hidden = true; if (save) save.hidden = true; if (sWas) sWas.hidden = true; }
  }
  function setAvailable(ok, label, stockInfo) {
    $all('[data-pdp-atc]').forEach(function (b) { if (ok) { b.removeAttribute('disabled'); } else { b.setAttribute('disabled', ''); } });
    $all('[data-pdp-atc-label]').forEach(function (s) { s.textContent = label; });
    /* voorraadregel in de mobiele balk meeschakelen met de gekozen variant */
    var stickyTxt = (stockInfo && stockInfo.sticky) ? stockInfo.sticky : (ok ? 'Op voorraad' : 'Tijdelijk uitverkocht');
    var stickyIsOut = stockInfo ? (stockInfo.state === 'out' && !/^(In bestelling|Pre-order),/i.test(stickyTxt)) : !ok;
    $all('[data-pdp-sticky-stock]').forEach(function (s) {
      s.textContent = stickyTxt;
      s.classList.toggle('is-uit', stickyIsOut);
    });
  }


  /* Gratis hoesje + screenprotector: uitklappen zodat de klant ziet wat hij krijgt */
  (function () {
    var knop = document.querySelector('[data-gift-open]');
    var pop = document.getElementById('giftpop');
    if (!knop || !pop) return;
    function open() {
      pop.hidden = false;
      document.body.style.overflow = 'hidden';
      knop.setAttribute('aria-expanded', 'true');
      var x = pop.querySelector('[data-gift-close]');
      if (x) x.focus();
    }
    function dicht() {
      pop.hidden = true;
      document.body.style.overflow = '';
      knop.setAttribute('aria-expanded', 'false');
      knop.focus();
    }
    knop.addEventListener('click', open);
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-gift-close]')) dicht();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) dicht();
    });
  }());

  /* Uitleg-popups: opslagkeuze en inruilen. Zelfde gedrag als de hoesje-popup,
     maar met een eigen knop, zodat de klant zelf kan opzoeken wat hij nodig heeft. */
  function koppelPopup(openSel, popId, sluitSel) {
    var knoppen = $all(openSel);
    var pop = document.getElementById(popId);
    if (!knoppen.length || !pop) return;
    function dicht() {
      pop.hidden = true;
      document.body.style.overflow = '';
      knoppen.forEach(function (k) { k.setAttribute('aria-expanded', 'false'); });
    }
    knoppen.forEach(function (k) {
      k.addEventListener('click', function () {
        pop.hidden = false;
        document.body.style.overflow = 'hidden';
        k.setAttribute('aria-expanded', 'true');
        var x = pop.querySelector(sluitSel);
        if (x) x.focus();
      });
    });
    pop.addEventListener('click', function (e) { if (e.target.closest(sluitSel)) dicht(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) dicht(); });
  }
  koppelPopup('[data-opslag-open]', 'opslagpop', '[data-opslag-close]');

  /* ---- Gallery: thumbs + pijlen + lightbox (coolblue-stijl) --------------- */
  var galIndex = 0;
  var galMedia = [];
  (function () {
    var el = $('[data-pdp-media]');
    if (el) { try { galMedia = JSON.parse(el.textContent); } catch (e) { galMedia = []; } }
  }());
  function galShow(i) {
    var thumbs = $all('[data-pdp-thumb]');
    var n = Math.max(galMedia.length, thumbs.length, 1);
    galIndex = ((i % n) + n) % n;
    var img = $('[data-pdp-main-image]');
    var t = thumbs[galIndex];
    if (img) {
      img.src = t ? t.getAttribute('data-image') : (galMedia[galIndex] || img.src);
      img.removeAttribute('srcset');
    }
    thumbs.forEach(function (x, k) { x.setAttribute('aria-selected', k === galIndex ? 'true' : 'false'); });
    if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    var c = $('[data-pdp-count-current]'); if (c) c.textContent = galIndex + 1;
  }
  $all('[data-pdp-thumb]').forEach(function (t, k) {
    t.addEventListener('click', function () { galShow(k); });
  });
  $all('[data-pdp-nav]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      galShow(galIndex + parseInt(b.getAttribute('data-pdp-nav'), 10));
    });
  });

  /* Lightbox: klik op de hoofdfoto = groot bekijken */
  var lb = $('[data-pdp-lightbox]');
  if (lb && galMedia.length) {
    document.body.appendChild(lb); /* uit de galerij-stacking-context tillen: altijd boven header/sticky */
    var lbImg = $('[data-pdp-lightbox-image]');
    var lbCur = $('[data-pdp-lightbox-current]');
    function lbShow(i) {
      var n = galMedia.length;
      galIndex = ((i % n) + n) % n;
      lbImg.src = galMedia[galIndex];
      if (lbCur) lbCur.textContent = galIndex + 1;
    }
    function lbOpen() { lbShow(galIndex); lb.hidden = false; document.body.style.overflow = 'hidden'; }
    function lbClose() { lb.hidden = true; document.body.style.overflow = ''; galShow(galIndex); }
    var mainImg = $('[data-pdp-main-image]');
    if (mainImg) {
      mainImg.style.cursor = 'zoom-in';
      mainImg.addEventListener('click', lbOpen);
    }
    var lbc = $('[data-pdp-lightbox-close]'); if (lbc) lbc.addEventListener('click', lbClose);
    $all('[data-pdp-lightbox-nav]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); lbShow(galIndex + parseInt(b.getAttribute('data-pdp-lightbox-nav'), 10)); });
    });
    lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbShow(galIndex - 1);
      if (e.key === 'ArrowRight') lbShow(galIndex + 1);
    });
  }

  /* ---- Charger inforow: flip 'geen oplader' -> 'oplader meegeleverd' ----- */
  function updateChargerRow() {
    var row = $('[data-charger-row]'); if (!row) return;
    var added = false;
    $all('[data-pdp-accessory]').forEach(function (ac) {
      if (ac.getAttribute('aria-checked') === 'true' && ac.getAttribute('data-acc-charger') === 'true') added = true;
    });
    var txt = row.querySelector('[data-charger-text]');
    if (txt) { txt.textContent = added ? (txt.getAttribute('data-incl') || txt.textContent) : (txt.getAttribute('data-none') || txt.textContent); }
    row.classList.toggle('is-charger-added', added);
  }

  /* ---- Accessory add-ons (multi; single-select within a data-acc-group) -- */
  $all('[data-pdp-accessory]').forEach(function (card) {
    function toggle() {
      var willCheck = card.getAttribute('aria-checked') !== 'true';
      var grp = card.getAttribute('data-acc-group');
      if (grp && willCheck) {
        $all('[data-pdp-accessory][data-acc-group="' + grp + '"]').forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
      }
      card.setAttribute('aria-checked', willCheck ? 'true' : 'false');
      showPrice(currentBase);
      updateChargerRow();
    }
    card.addEventListener('click', toggle);
    card.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); } });
  });
  updateChargerRow();

  /* ---- Add to cart (main + optional accessory) -------------------------- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      /* Line item properties uit het formulier meesturen. Deze tak bouwt zijn
         eigen JSON en negeerde daarmee elk hidden properties[...]-veld, dus de
         cadeauregel kwam nooit op de bestelling terwijl hij wel in het formulier
         stond. Generiek gehouden: elk properties[...]-veld gaat mee, BEHALVE een
         uitgeschakeld veld (disabled), net als bij een gewoon formulier. Het
         pre-orderveld staat op elke productpagina en is alleen aan bij een echte
         pre-order; zonder die controle kreeg elk toestel 'Pre-order: leverbaar
         vanaf' op de bestelling (13-09, 9 orders). */
      var props = {};
      Array.prototype.forEach.call(form.querySelectorAll('[name^="properties["]'), function (el) {
        if (el.disabled || !el.value) return;
        var m = (el.getAttribute('name') || '').match(/^properties\[(.+)\]$/);
        if (m) props[m[1]] = el.value;
      });
      var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
      if (Object.keys(props).length) items[0].properties = props;
      /* LET OP, deze tak VUURT WEL. Hier stond jarenlang dat geen enkel sjabloon
         data-pdp-free-variant zet en dat dit blok dus dood was. Dat klopt niet
         meer: op 27-08 gemeten op de live productpagina van de S25 staat het
         attribuut er wel degelijk (variant 54601777938773).

         Waarom dat uitmaakt: /cart/add.js TELT OP. Elke keer dat de klant het
         toestel toevoegt komt er dus een cadeau bij, ook als hij hetzelfde
         toestel twee keer toevoegt en het aantal daarna weer verlaagt. Zo kreeg
         JPS#261412 drie gratis hoesjes bij twee telefoons.

         Het aantal wordt rechtgetrokken door de correctie onderaan
         sections/main-cart.liquid, en die pagina blokkeert nu de kassaknop
         zolang dat nog moet gebeuren. Wil je het bij de bron oplossen, laat deze
         tak dan het juiste aantal ZETTEN via /cart/update.js in plaats van +1 te
         pushen via add.js.

         Vertrouw een opmerking als deze nooit als meting: kijk in de gerenderde
         pagina of het attribuut er staat. */
      /* querySelectorAll, niet querySelector: een toestel kan twee cadeaus hebben
         (hoesje EN screenprotector). Met de oude enkelvoudige selector kwam alleen
         het hoesje op de bestelling en miste het glas op de pakbon. */
      /* BEWUST UITGEZET op 28-08. Hier werd bij ELKE add een cadeau met aantal 1
         gepusht via /cart/add.js, en dat telt op. Voegde de klant het toestel
         twee keer toe en verlaagde hij daarna het aantal, dan bleven er twee
         cadeaus staan. De winkelwagen beloofde dan meer dan er verzonden werd,
         de klant rekende daarop af en klaagde terecht. JPS#261389, 261412 en
         261427 zijn zo ontstaan, en er zijn slechte reviews uit gekomen.

         Drie eerdere reparaties (16-08, 25-08, 27-08) hebben elk een echte weg
         dichtgezet en telkens kwam er een nieuwe order fout binnen. Het probleem
         was dus niet de reparatie maar de opzet: een cadeau als losse regel in
         de winkelwagen is een tweede plek waar een aantal kan staan, en die kan
         uit de pas lopen met het toestel.

         De verpakinstructie hangt NIET aan deze regel maar aan het toestel zelf,
         als regeleigenschap "Gratis erbij" (gemeten op JPS#261427: staat er
         volledig op, hoesje plus screenprotector). Het magazijn verliest dus
         niets. De klant ziet het cadeau nu als tekst ONDER zijn toestel in de
         winkelwagen, waar het aantal per definitie klopt.

         Wil je het cadeau ooit weer als echte regel, doe dat dan server-side via
         een automatische BxGy-korting of een Cart Transform Function, niet hier:
         in de kassa van Shopify kan de klant nog aantallen wijzigen en daar kan
         het thema niets synchroniseren. */
      $all('[data-pdp-accessory]').forEach(function (card) {
        if (card.getAttribute('aria-checked') === 'true') {
          var aid = parseInt(card.getAttribute('data-variant-id'), 10);
          if (aid) items.push({ id: aid, quantity: 1 });
        }
      });
      var btns = $all('[data-pdp-atc]');
      btns.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) {
          /* Shopify zet de leesbare reden in description; die werd nooit gelezen
             en de klant belandde zonder uitleg op /cart. */
          return r.json().then(function (j) {
            var m = (j && (j.description || j.message)) || 'Dat lukte niet, probeer het opnieuw';
            if (window.__joepsToast) window.__joepsToast(m); else alert(m);
          }).catch(function () {
            if (window.__joepsToast) window.__joepsToast('Dat lukte niet, probeer het opnieuw');
          });
        }
        return r.json().then(function () {
          if (window.__joepsCartCount) window.__joepsCartCount();
          if (window.__joepsToast) window.__joepsToast('Toegevoegd aan winkelwagen');
        });
      }).catch(function () { form.submit(); })
        .finally(function () { btns.forEach(function (b) { b.removeAttribute('aria-disabled'); }); });
    });
  }
}());
